import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection, getManager } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { PlantOperationCapacityDto } from './dto/plant-operation-capacity.dto';
import { PlantOperationCapacityAdapter } from './dto/plant-operation-capacity.adapter';
import { PlantOperationCapacityRequest } from './dto/plant-operation-capacity.request';
import { ALLPlantOprationCapacityResponse,PlantIdRequest,PlantOperationCapacityResponse } from '@gtpl/shared-models/masters';
import { PlantOperationCapacity } from './plant-operation-capacity.entity';
import appSettings from 'apps/services/config';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { plantIdRequest } from '../rm-rack-position/dto/plant-request';
@Injectable()
export class PlantOperationCapacityService {
    
   
    constructor(
      private logService:LogsService,

        @InjectRepository( PlantOperationCapacity) private plantoperationcapacityReposistory: Repository<PlantOperationCapacity>,
        private  PlantOperationCapacityAdapter:PlantOperationCapacityAdapter,
    ) { }
   
    async createPlantOperationCapacity( plantOperationCapacityDto:PlantOperationCapacityDto,isUpdate:boolean,request:Request):Promise<PlantOperationCapacityResponse>{
        try{
            if (!isUpdate) {
                const plantOperationCapacityEntity=await this.getPlantOperationCapacityWithoutRelations(plantOperationCapacityDto.plantId,plantOperationCapacityDto.operationId);
            if (plantOperationCapacityEntity) {
                throw new  PlantOperationCapacityResponse(false,11104, 'Plant Operation Capacity already exists'); 
            }   
            } 
            else{ 
                const plantOperationCapacityEntity=await this.getPlantOperationCapacityWithoutRelations(plantOperationCapacityDto.plantId,plantOperationCapacityDto.operationId);
                if(plantOperationCapacityEntity){
                    if (plantOperationCapacityEntity.plantOperationId!=plantOperationCapacityDto.plantOperationId){
                        throw new PlantOperationCapacityResponse(false,11104, 'Plant Operation Capacity  already exists');   
                    }    
                } 
            }
         const convertedplantOperationCapacityEntity:PlantOperationCapacity=this.PlantOperationCapacityAdapter.convertDtoToEntity( plantOperationCapacityDto,isUpdate);
         const savedplantOperationCapacityEntity:PlantOperationCapacity=await this.plantoperationcapacityReposistory.save(convertedplantOperationCapacityEntity);
         const savedplantOperationCapacityDTO:PlantOperationCapacityDto=this.PlantOperationCapacityAdapter.convertEntityToDto(savedplantOperationCapacityEntity);

         if(savedplantOperationCapacityDTO){
             const response = new PlantOperationCapacityResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Plant Operation Capacity updated Successfully':'Plant Operation Capacity created successfully',savedplantOperationCapacityDTO); 
             const name=isUpdate?'updated':'created'
             const newLogDto = new LogsDto(1,name, 'PlantOperationCapacity', savedplantOperationCapacityDTO.plantOperationId, true, '',savedplantOperationCapacityDTO.createdUser)
             let res = await this.logService.createLog(newLogDto);
             console.log(res);
             return response;
         } else { 
            throw new PlantOperationCapacityResponse(false,11106,'Plant Operation Capacity saved but issue while transforming into DTO');
        }
        }
        catch (error) {
            return error;
          }
    }
 
   
     /**
     * get country details
     * @param plantId 
     */
    // @LogActions({isAsync: true})
    async getPlantOperationCapacityWithoutRelations(plantId:number,operationId:number): Promise<PlantOperationCapacity> {
        
        const PlantOperationCapacityResponse = await this.plantoperationcapacityReposistory.findOne({
        where: {plantId:plantId,operationId:operationId}
        });
        // console.log(PlantOperationCapacityResponse);
        if (PlantOperationCapacityResponse) {
        return PlantOperationCapacityResponse;
        } else {
        return null;
        }
    }
    /**
     * It deactivates value   Plant operation capacity   
     * @param itemReq     Plant operation capacity as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivatePlantOperationCapacity( plantOperationCapacityReq: PlantOperationCapacityRequest): Promise<PlantOperationCapacityResponse> {
        try {
            const plantOperationCapacityExists = await this.getPlantOperationCapacityById(plantOperationCapacityReq.plantOperationId);
            if (plantOperationCapacityExists) {
                if (plantOperationCapacityReq.versionFlag !== plantOperationCapacityExists.versionFlag) {
                    throw new PlantOperationCapacityResponse(false,10113, 'Someone updated the current PlantOperationCapacity information.Refresh and try again');
                } else {
                    
                        const plantOperationCapacityStatus =  await this.plantoperationcapacityReposistory.update(
                            { plantOperationId: plantOperationCapacityReq.plantOperationId },
                            { isActive: plantOperationCapacityReq.isActive,updatedUser: plantOperationCapacityReq.updatedUser });
                       
                        if (plantOperationCapacityExists.isActive) {
                            if (plantOperationCapacityStatus.affected) {
                                const plantOperationCapacityResponse: PlantOperationCapacityResponse = new PlantOperationCapacityResponse(true, 10115, 'Plant Operation Capacity is de-activated successfully');
                                return plantOperationCapacityResponse;
                            } else {
                                throw new PlantOperationCapacityResponse(false,10111, 'Plant Operation Capacity is already deactivated');
                            }
                        } else {
                            if (plantOperationCapacityStatus.affected) {
                                const plantOperationCapacityResponse: PlantOperationCapacityResponse = new PlantOperationCapacityResponse(true, 10114, 'Plant Operation Capacity is activated successfully');
                                return plantOperationCapacityResponse;
                            } else {
                                throw new PlantOperationCapacityResponse(false,10112, 'Plant Operation Capacity is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getAllPlantOperationCapacity(req:PlantIdRequest): Promise<ALLPlantOprationCapacityResponse> {
        try{
            const manager = getManager();
            let query
             query = 'SELECT p.plant_operation_capacity as plantOperationId, p.operation_id as operationId,p.min_count as mincount,p.max_count as maxcount ,o.operation_name as operationName, uc.unit_name as plantName,p.is_active as isActive,p.created_user as createdUser,p.updated_user as updatedUser,p.plant_Id as plantId,p.version_flag as versionFlag FROM ' + appSettings.masters_db  + '.plant_operation_capacity p LEFT JOIN ' + appSettings.masters_db + '.unitcodes uc ON uc.unit_code_id = p.plant_id LEFT JOIN ' + appSettings.production_db + '.operations o ON o.operation_id = p.operation_id where plant_operation_capacity>0  '  
            if(req.unitcodeId != 5){
                query = query +' and p.plant_id ='+req.unitcodeId+' '
            }else{
             query = query
            }
            const data = await manager.query(query)

            if(data.length > 0){
            const response = new ALLPlantOprationCapacityResponse(true, 11208, "Racks retrieved successfully", data);
            
            const newLogDto = new LogsDto(1,'view', 'PlantOperationCapacity', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
            }else{
                throw new PlantOperationCapacityResponse(false,99998,'No Record Found');
            }
           
            
        }catch(err){
            return err
        }

    }



    async getPlantOperationCapacityById( plantOperationId: number): Promise<PlantOperationCapacity> {
        //  console.log(employeeId);
            const response = await this.plantoperationcapacityReposistory.findOne({
            where: { plantOperationId:  plantOperationId},
            });
            
            if (response) {
            return response;
            } else {
            return null;
            }
        }



































}
